export const CHECKBOX = 'checkbox';
export const DATE_FIELD = 'date';
export const DROPDOWN = 'dropdown';
export const EMPTY = null;
export const TEXT_AREA = 'text';
export const TEXT_FIELD = 'field';

export const FIELD_TYPES = {
  CHECKBOX,
  DATE_FIELD,
  DROPDOWN,
  TEXT_AREA,
  TEXT_FIELD,
} as const;

export const COLUMN_SIZE_1 = 1;
export const COLUMN_SIZE_2 = 2;
export const COLUMN_SIZE_3 = 3;
export const COLUMN_SIZE_4 = 4;
export const COLUMN_OPTIONS = [
  COLUMN_SIZE_1,
  COLUMN_SIZE_2,
  COLUMN_SIZE_3,
  COLUMN_SIZE_4,
] as const;

export const FIELD_SIZE_20 = 0;
export const FIELD_SIZE_40 = 1;
export const FIELD_SIZE_50 = 2;
export const FIELD_SIZE_60 = 3;
export const FIELD_SIZE_80 = 4;
export const FIELD_SIZE_100 = 5;

export const FIELD_SIZE_OPTIONS = [
  FIELD_SIZE_20,
  FIELD_SIZE_40,
  FIELD_SIZE_50,
  FIELD_SIZE_60,
  FIELD_SIZE_80,
  FIELD_SIZE_100,
] as const;
